import { useQuery } from '@tanstack/react-query';
import { ApiClient } from '@utils/apiClient';
import { API_ENDPOINTS } from './constants';
import type { Plan } from './types';

// Public price list of the registration: the current standard version of every tier.
export const usePlans = () =>
  useQuery({
    queryKey: ['billing', 'plans'],
    queryFn: async (): Promise<Plan[]> => {
      const response = await ApiClient.get(API_ENDPOINTS.PLANS);
      if (!response.ok) throw new Error(`Failed to load plans (${response.status})`);
      return (await response.json()) as Plan[];
    },
    staleTime: 5 * 60 * 1000,
  });
